export default __webpack_public_path__ + "static/media/emailNotebook.50fc9050.png";